import { render, staticRenderFns } from "./diagnosisTreatment.vue?vue&type=template&id=9c8920a8&scoped=true"
import script from "./diagnosisTreatment.vue?vue&type=script&lang=js"
export * from "./diagnosisTreatment.vue?vue&type=script&lang=js"
import style0 from "./diagnosisTreatment.vue?vue&type=style&index=0&id=9c8920a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8920a8",
  null
  
)

export default component.exports